import styled, {css} from "styled-components";

const LogoWrap = styled.div`
    background: #FFFFFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({size}) => css`
        width: ${size}px;
        height: ${size}px;
        flex: 0 ${size}px;
      img {
            width: ${size * 0.6}px;
            height: ${size * 0.6}px;
        }
    `}
`

export const TeamLogo = ({logo, size}) => (
    <LogoWrap size={size}>
        <img src={logo} alt=""/>
    </LogoWrap>
)